<template>
  <section class="cool-picker" id="picker">
  </section>
</template>

<script>
import Util from '@/utils/util'
import MobileSelect from 'mobile-select'

let customData = {
  key: ''
}

export default {
  name: 'picker',
  data() {
    return {
      pickerShow: false
    }
  },
  computed: {},
  methods: {
    confirm(index, data) {
      let value = ''
      data.forEach((v, i) => {
        value += Util.htmlDecodeByRegExp(v) + ' '
      })
      value = value.trim()
      this.$emit('confirmPicker', {
        key: customData.key,
        value: value,
        valArr: data,
        index: index
      })
    }
  },
  mounted() {
    let self = this
    let mobileSelect = new MobileSelect({
      trigger: '#picker',
      triggerDisplayData: false,
      title: '',
      wheels: [
        {data: [1, 2]}
      ],
      callback(index, data) {
        console.log('picker callback ', index, data)
        self.confirm(index, data)
      },
      // position: [2] // Initialize positioning
      cancel(index, data) {},
      // onShow() {},
      onHide() {
        self.pickerShow = false
        self.$emit('pickerHide')
      },
      maskOpacity: 0.4
    });
    // mobileSelect.show()
    // mobileSelect.hide()
    // mobileSelect.setTitle()
    // mobileSelect.locatePosition()
    // mobileSelect.updateWheel()
    // mobileSelect.updateWheels()
    // mobileSelect.getValue()
    this.$on('showPicker', picker => {
      if (this.pickerShow) return
      customData.key = picker.key
      for (let i in picker.data) {
        mobileSelect.updateWheel(i, picker.data[i].data)
        mobileSelect.locatePosition(i, picker.initIndex[i] || 0)
      }
      mobileSelect.show()
      this.pickerShow = true
      // console.log('showPicker', mobileSelect, picker)
    })
  }
}
</script>

<style scoped lang="scss">
</style>
